module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/military-maneuvers-cancel.2f4244c4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/military-maneuvers-cancel.png
// module id = 3743
// module chunks = 11